<template>
  <div id="home">
    <Navbar current="Dashboard" />
    <Sidebar />
    <Container col="col-12">
      <Header
        :isSubHeader="false"
        title="Dashboard"
        :iconClass="'fa-solid fa-chart-simple text-primary'"
      />

      <!-- Abas -->
      <ul class="nav nav-tabs mb-4">
        <li v-for="tab in tabs" :key="tab.id" class="nav-item">
          <a
            class="nav-link cursor-pointer"
            :class="{ active: activeTab === tab.id }"
            @click.prevent="selectTab(tab.id)"
          >
            <i :class="tab.icon" class="me-1"></i>
            {{ tab.label }}
          </a>
        </li>
      </ul>

      <!-- Big Numbers: sem filtro, busca única no pai -->
      <div v-show="activeTab === 'big'">
        <div v-if="bigLoading" class="text-center py-6 text-muted">
          <div class="spinner-border text-primary mb-3" role="status"></div>
          <p class="mb-0">Carregando...</p>
        </div>
        <div v-else-if="bigErrored" class="text-center py-6 text-muted">
          <i class="fa-solid fa-triangle-exclamation fa-2x mb-3"></i>
          <p class="mb-2">Não foi possível carregar os dados.</p>
          <button class="btn btn-sm btn-outline-primary" @click="loadBigNumbers">
            Tentar novamente
          </button>
        </div>
        <DashBigNumbers v-else-if="bigData" :data="bigData" @navigate="selectTab" />
      </div>

      <!-- Abas com filtro de período: cada uma se auto-busca -->
      <div v-show="activeTab === 'psychologists'" v-if="mountedTabs.psychologists">
        <DashPsychologists />
      </div>
      <div v-show="activeTab === 'patients'" v-if="mountedTabs.patients">
        <DashPatients />
      </div>
      <div v-show="activeTab === 'funnel'" v-if="mountedTabs.funnel">
        <DashFunnel />
      </div>
      <div v-show="activeTab === 'appointments'" v-if="mountedTabs.appointments">
        <DashAppointments />
      </div>
      <div v-show="activeTab === 'financial'" v-if="mountedTabs.financial">
        <DashFinancial />
      </div>
    </Container>
  </div>
</template>

<script>
import HomeController from "./HomeController";
export default HomeController;
</script>

<style scoped>
.py-6 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
</style>
